import { EBookingActivityStatus, ITypeCode } from "services/CrmApi/types/DirectoryEntry";

export const SET_TYPE_FILTER = 'crm/SET_TYPE_FILTER';
export const SET_COUNTRY_FILTER = 'crm/SET_COUNTRY_FILTER';
export const SET_STAGE_FILTER = 'crm/SET_STAGE_FILTER';
export const SET_SCORE_FILTER = 'crm/SET_SCORE_FILTER';
export const SET_MANAGER_TEXT_FILTER = 'crm/SET_MANAGER_TEXT_FILTER';
export const SET_MANAGER_FILTER = 'crm/SET_MANAGER_FILTER';
export const SET_TERM_FILTER = 'crm/SET_TERM_FILTER';
export const RESET_WHOLE_FILTER = 'crm/RESET_WHOLE_FILTER';
export const SET_BOOKING_ACTIVITY_FILTER = 'crm/SET_BOOKING_ACTIVITY_FILTER';
export const IS_DIRTY_EDIT_COMPANY_PROFILE = 'crm/IS_DIRTY_EDIT_COMPANY_PROFILE';
export const IS_DIRTY_EDIT_CONTACT_PROFILE = 'crm/IS_DIRTY_EDIT_CONTACT_PROFILE';
export const OPEN_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL = 'crm/OPEN_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL';
export const CLOSE_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL = 'crm/CLOSE_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL';
export const OPEN_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL = 'crm/OPEN_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL';
export const CLOSE_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL = 'crm/CLOSE_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL';
export const SET_NOTIFICATIONS_SUBSCRIPTION_PENDING = 'crm/SET_NOTIFICATIONS_SUBSCRIPTION_PENDING';
export const SET_CONFIRMED_FILTERS = 'crm/SET_CONFIRMED_FILTERS';

export type SetTypeFilterAction = ReturnType<typeof setTypeFilterAction>;
export const setTypeFilterAction = (value: ITypeCode[]) => ({
  type: SET_TYPE_FILTER as typeof SET_TYPE_FILTER,
  value,
});  

export type SetCountryFilterAction = ReturnType<typeof setCountryFilterAction>;
export const setCountryFilterAction = (value: string[]) => ({
  type: SET_COUNTRY_FILTER as typeof SET_COUNTRY_FILTER,
  value,
});  

export type SetStageFilterAction = ReturnType<typeof setStageFilterAction>;
export const setStageFilterAction = (value: string | null) => ({
  type: SET_STAGE_FILTER as typeof SET_STAGE_FILTER,
  value,
});  

export type SetScoreFilterAction = ReturnType<typeof setScoreFilterAction>;
export const setScoreFilterAction = (value: number | null) => ({
  type: SET_SCORE_FILTER as typeof SET_SCORE_FILTER,
  value,
});     

export type SetManagerTextFilterAction = ReturnType<typeof setManagerTextFilterAction>;
export const setManagerTextFilterAction = (value: string) => ({
  type: SET_MANAGER_TEXT_FILTER as typeof SET_MANAGER_TEXT_FILTER,
  value,
});      

export type SetManagerFilterAction = ReturnType<typeof setManagerFilterAction>;
export const setManagerFilterAction = (value: string | null) => ({
  type: SET_MANAGER_FILTER as typeof SET_MANAGER_FILTER,
  value,
});     

export type SetTermFilterAction = ReturnType<typeof setTermFilterAction>;
export const setTermFilterAction = (value: string) => ({
  type: SET_TERM_FILTER as typeof SET_TERM_FILTER,
  value,
});    

export type ResetWholeFilterAction = ReturnType<typeof resetWholeFilterAction>;
export const resetWholeFilterAction = () => ({
  type: RESET_WHOLE_FILTER as typeof RESET_WHOLE_FILTER,
});

export type SetIsDirtyEditCompanyProfileFormAction = ReturnType<typeof setIsDirtyEditCompanyProfileFormAction>;
export const setIsDirtyEditCompanyProfileFormAction = (value: boolean) => ({
  type: IS_DIRTY_EDIT_COMPANY_PROFILE as typeof IS_DIRTY_EDIT_COMPANY_PROFILE,
  value,
});

export type SetIsDirtyEditContactProfileFormAction = ReturnType<typeof setIsDirtyEditContactProfileFormAction>;
export const setIsDirtyEditContactProfileFormAction = (value: boolean) => ({
  type: IS_DIRTY_EDIT_CONTACT_PROFILE as typeof IS_DIRTY_EDIT_CONTACT_PROFILE,
  value,
});

export type OpenSubscribeToAllNotificationsModalAction = ReturnType<typeof openSubscribeToAllNotificationsModalAction>;
export const openSubscribeToAllNotificationsModalAction = () => ({
  type: OPEN_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL as typeof OPEN_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL,
});

export type CloseSubscribeToAllNotificationsModalAction = ReturnType<typeof closeSubscribeToAllNotificationsModalAction>;
export const closeSubscribeToAllNotificationsModalAction = () => ({
  type: CLOSE_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL as typeof CLOSE_SUBSCRIBE_TO_ALL_NOTIFICATIONS_MODAL,
});

export type OpenUnsubscribeFromAllNotificationsModalAction = ReturnType<typeof openUnsubscribeFromAllNotificationsModalAction>;
export const openUnsubscribeFromAllNotificationsModalAction = () => ({
  type: OPEN_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL as typeof OPEN_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL,
});

export type CloseUnsubscribeFromAllNotificationsModalAction = ReturnType<typeof closeUnsubscribeFromAllNotificationsModalAction>;
export const closeUnsubscribeFromAllNotificationsModalAction = () => ({
  type: CLOSE_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL as typeof CLOSE_UNSUBSCRIBE_FROM_ALL_NOTIFICATIONS_MODAL,
});

export type SetNotificationsSubscriptionPendingAction = ReturnType<typeof setNotificationsSubscriptionPendingAction>;
export const setNotificationsSubscriptionPendingAction = (value: boolean) => ({
  type: SET_NOTIFICATIONS_SUBSCRIPTION_PENDING as typeof SET_NOTIFICATIONS_SUBSCRIPTION_PENDING,
  value,
});

export type SetBookingActivityFilterAction = ReturnType<typeof setBookingActivityFilterAction>;
export const setBookingActivityFilterAction = (value: EBookingActivityStatus | null) => ({
  type: SET_BOOKING_ACTIVITY_FILTER as typeof SET_BOOKING_ACTIVITY_FILTER,
  value,
});

export type SetConfirmedFiltersAction = ReturnType<typeof setConfirmedFiltersAction>;
export const setConfirmedFiltersAction = () => ({
  type: SET_CONFIRMED_FILTERS as typeof SET_CONFIRMED_FILTERS,
});

export type CrmAction =
  | SetTypeFilterAction
  | SetCountryFilterAction
  | SetStageFilterAction
  | SetScoreFilterAction
  | SetManagerTextFilterAction
  | SetManagerFilterAction
  | SetTermFilterAction
  | ResetWholeFilterAction
  | SetIsDirtyEditCompanyProfileFormAction
  | SetIsDirtyEditContactProfileFormAction
  | OpenSubscribeToAllNotificationsModalAction
  | CloseSubscribeToAllNotificationsModalAction
  | OpenUnsubscribeFromAllNotificationsModalAction
  | CloseUnsubscribeFromAllNotificationsModalAction
  | SetNotificationsSubscriptionPendingAction
  | SetConfirmedFiltersAction
  | SetBookingActivityFilterAction;
